module.exports = __webpack_public_path__ + "static/media/nextLive.6293e7b2.svg";